import { Nav } from "../components/site/Nav";
import { Hero } from "../components/site/Hero";
import { Vision } from "../components/site/Vision";
import { FiveHundred } from "../components/site/FiveHundred";
import { PressBar } from "../components/site/PressBar";
import { Manifesto } from "../components/site/Manifesto";
import { Story } from "../components/site/Story";
import { Collage } from "../components/site/Collage";
import { Program } from "../components/site/Program";
import { CommunityReading } from "../components/site/CommunityReading";
import { AboutMe } from "../components/site/AboutMe";
import { Pricing } from "../components/site/Pricing";
import { TryCourse } from "../components/site/TryCourse";
import { Newsletter } from "../components/site/Newsletter";
import { WhyFinal } from "../components/site/WhyFinal";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="relative overflow-x-clip bg-ivory">
      <div className="grain-overlay" />
      <Nav />
      <main>
        <Hero />
        <PressBar />
        <Vision />
        <FiveHundred />
        <Manifesto />
        <Story />
        <Collage />
        <Program />
        <CommunityReading />
        <AboutMe />
        <Pricing />
        <TryCourse />
        <Newsletter />
        <WhyFinal />
      </main>
    </div>
  );
}
